import { render } from "./button-group.presentational.vue?vue&type=template&id=9f97bd42"
import script from "./button-group.presentational.vue?vue&type=script&lang=js"
export * from "./button-group.presentational.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__